import styled from 'styled-components';
import { IC_DELIVERY_TRUCK, IC_EXPRESS_NEW, IC_OFF_BOX } from '../../Assets/images';

export const ServiceItemStyled = styled.div`
  display: flex;
  flex-wrap: wrap;

  .badgeStack {
    position: absolute;
    top: 0;
    left: 0;
    padding: 10px 0 0 10px;
    z-index: 1;
  }

  .offer-tost {
    width: 80px;
    height: 24px;
    color: ${(props) => props?.theme?.color?.white};
    font-weight: 700;
    background: url(${IC_OFF_BOX.src}) no-repeat 100% 50% / cover;
    display: flex;
    align-items: center;
    padding-left: 6px;
    margin-bottom: 6px;

    span {
      margin-left: 3px;
      font-size: 11px;
    }

    @media (max-width: 480px) {
      width: 67px;
      height: 20px;
      font-size: 13px;
    }
  }

  .ic-express {
    position: absolute;
    top: 40px;
    left: 0;
    img {
      border-radius: 0;
    }
  }
  .ic-express-top {
    position: absolute;
    top: 16px;
    left: 0;
    img {
      border-radius: 0;
    }
  }
  .link {
    color: ${(props) => props.theme.green.dark};
    &:hover {
      color: ${(props) => props.theme.green.light};
    }
  }
  .dealItemBox {
    width: 100%;
    max-width: 208px;
    margin: 0 6px;
    a {
      width: 100%;
      text-decoration: none;
      color: inherit;
    }
    .item {
      width: 100%;
      height: 100%;
      padding: 8px;
      background: ${(props) => props.theme.color.white};
      border: 1px solid ${(props) => props.theme.color.lightGray};
      border-radius: 8px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .addToWishList {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;

        img {
          border-radius: 0;
        }
      }

      .offTag {
        font-size: 13px;
        font-weight: 700;
        color: ${(props) => props.theme.color.white};
        background: ${(props) => props.theme.verification.red.main};
        padding: 5px 10px;
        border-radius: 8px 0;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .imgWrapper {
        width: 100%;
        text-align: center;
        position: relative;
        padding-bottom: 8px;
        margin-bottom: 8px;

        > div {
          height: 140px;
          // margin: 20px auto 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      .exclusive-wrapper {
        min-height: 32px;
        .exclusive {
          max-width: 152px;
          color: ${(props) => props.theme.color.white};
          background: ${(props) => props.theme.blue.dark};
          font-size: 10px;
          font-weight: 700;
          padding: 5px 5px 5px 10px;
          text-transform: uppercase;
          position: relative;
          white-space: nowrap;
          margin: 0 0 8px 0;
          display: inline-flex;

          span {
            width: 100%;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          &:before {
            border-top: 13px solid ${(props) => props.theme.blue.dark};
            border-right: 10px solid transparent;
            border-left: 10px solid transparent;
            content: '';
            position: absolute;
            top: 0;
            left: 100%;
          }

          &:after {
            border-top: 25px solid transparent;
            border-right: 25px solid transparent;
            border-left: 20px solid ${(props) => props.theme.blue.dark};
            content: '';
            position: absolute;
            bottom: 0;
            left: 100%;
          }
        }
      }
      .discountEndsWrapper {
        width: auto !important;
        height: 30px !important;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
      }
      .discountEnds {
        background: ${(props) => props?.theme?.verification?.red?.off};
        padding: 6px;
        border-radius: 2px;
        display: inline-flex;
        justify-content: center;
        align-items: center;

        .timer {
          color: ${(props) => props?.theme?.color?.red};
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0;
          margin-left: 6px;
        }
      }
      .name {
        width: 176px;
        font-family: 'Mulish';
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        color: ${(props) => props?.theme?.text?.dark};
        margin: 0 0 6px 0 !important;
      }
      .price {
        width: 100%;
        margin: 0 0 8px 0;
        display: flex;
        align-items: center;

        .new {
          font-size: 16px;
          font-weight: 700;
          margin: 0 5px 0 0;
        }
        .actual {
          color: ${(props) => props.theme.text.medium};
          font-size: 12px;
          font-weight: 600;
          text-decoration: line-through;
        }
      }
      .homeCareCart {
        flex-direction: column;
      }
      .delivery {
        height: 39px;
        background: url(${IC_DELIVERY_TRUCK.src}) no-repeat 0 8px / 16px;
        color: ${(props) => props.theme.text.medium};
        font-size: 12px;
        font-weight: 600;
        text-align: left;
        padding: 3px 0 0 21px;
        margin: 0 0 8px 0;
        overflow: hidden;

        span {
          font-weight: 700;
        }

        &.express {
          background: url(${IC_EXPRESS_NEW.src}) no-repeat 0 6px / 43px;
          padding-left: 48px;

          span {
            font-weight: 600;
          }
        }
      }
      .earliestSlot {
        background: ${(props) => props.theme.green.off};
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 4px 6px;
        border-radius: 0px 4px 4px 0px;
        padding-right: 32px;

        .text {
          font-family: 'Mulish';
          font-style: normal;
          font-weight: 500;
          font-size: 10px;
          line-height: 13px;
          display: flex;
          align-items: center;
          color: ${(props) => props.theme.green.dark};
        }

        &.custom-margin {
          margin-bottom: 41px;
          padding-right: 32px;
        }
      }
    }

    .noSlot {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 4px 6px;
      width: 104px;
      height: auto;
      background: ${(props) => props?.theme?.verification?.red?.off};
      border-radius: 0px 4px 4px 0px;
      flex: none;
      order: 1;
      flex-grow: 0;

      .noSlotAvailable {
        width: 92px;
        height: 13px;
        font-family: 'Mulish';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 13px;
        display: flex;
        align-items: center;
        color: ${(props) => props?.theme?.verification?.red?.main};
        flex: none;
        order: 0;
        flex-grow: 0;
      }
    }

    .outofstock {
      height: 39px;
      font-size: 13px;
      overflow: hidden;
    }
  }

  &.inProductList {
    .dealItemBox {
      .item {
        padding: 16px 10px;
      }
    }
  }

  .img > div {
    position: inherit;
    border-radius: 4px;
  }

  @media (max-width: 820px) {
    padding: 0;

    .dealItemBox {
      max-width: unset;
      margin: 0 6px;
    }
  }

  .package-rx-indicator {
    display: flex;
    .package {
      width: 50px;
      height: 15px;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      line-height: 15px;
      color: ${(props) => props.theme.mandalay.dark};
      flex: none;
      order: 0;
      flex-grow: 0;
    }
    .dot {
      padding-left: 6px;
      padding-right: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      > div {
        display: block !important;
      }
    }
    .vector {
      padding-right: 2px;
      > div {
        display: block !important;
      }
    }
    .required {
      width: 51px;
      height: 15px;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      color: ${(props) => props.theme.text.light};
      flex: none;
      order: 1;
      flex-grow: 0;
    }
  }

  .serviceTime {
    display: flex;
    align-items: center;
    margin-top: 8px;

    .clock {
      display: flex;
      padding-right: 2px;

      > div {
        display: block;
      }
    }

    .text {
      height: 15px;
      font-family: 'Mulish';
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 15px;
      color: ${(props) => props.theme.grey.dark};
    }
    .textSecond {
      line-height: 15px;
      font-family: 'Mulish';
      font-size: 12px;
      font-style: italic;
      color: #78909C;
      padding-right: 2px;
    }
  }

  @media (max-width: 480px) {
    .row {
      .col-lg-12 {
        padding: 0;
      }
    }

    .dealItemBox {
      max-width: 100%;
      margin: 0;

      .item {
        padding: 10px;
        border-radius: 0;
        border-left: 0;
        border-top: 0;

        .badgeStack {
          .wrapper {
            font-size: 11px;
          }
        }
        .addToWishList {
          top: 10px;
          right: 8px;
        }
        .imgWrapper {
          padding-bottom: 0;
          > div {
            width: 100px;
            height: 135px;
          }
        }
        .name {
          height: 36px;
          font-size: 14px;
          line-height: 17px;
          margin-bottom: 2px;
        }
        .price {
          font-size: 13px;
          margin-bottom: 2px;

          .new {
            font-size: 14px;
          }
        }
        .delivery {
          height: 30px;
          background-position: 0 6px;
          font-size: 11px;
          line-height: 14px;
          margin-bottom: 4px;
        }
        .add-to-cart {
          .quantity-wrapper {
            .dropdown-wrapper.dropdown {
              .dropdown-toggle {
                height: 34px;
                font-size: 13px;
                padding: 5px 30px;
              }
              .txtLoading {
                font-size: 12px;
              }
            }
            .decrease-product {
              width: 18px;
              height: 18px;
              left: 6px;
              top: 8px;

              img {
                border-radius: 0;
              }
            }
            .increase_product {
              width: 18px;
              height: 18px;
              right: 6px;
              top: 8px;

              img {
                border-radius: 0;
              }
            }
          }
          .btn {
            font-size: 12px;
          }
        }
        .outofstock {
          height: 30px;
          font-size: 12px;
          margin-bottom: 4px !important;
        }
      }
    }
  }
  @media (max-width: 380px) {
    .slick-slide {
      width: 65vw !important;
    }
  }
`;
